module.exports = __webpack_public_path__ + "img/img-86.342dfa9f.png";